export interface ITicketSelectorErrorMessages {
  title: string;
  options: string;
}

export interface ITicketSelectorErrorValues {
  customerType: ITicketSelectorErrorMessages;
  zone: ITicketSelectorErrorMessages;
  travelMethod: ITicketSelectorErrorMessages;
  travelTime: ITicketSelectorErrorMessages;
}
